import getDeviceInfo from '@/lib/base/getDeviceInfo';
import NAVIGATION from '@/constant/navigation.js';
const deviceDetails = getDeviceInfo();
const {viewMode} = deviceDetails;
const isMobile = viewMode === 'phone';

export default [
  {
    path: '/teacher-management',
    name: 'teacherManagement',
    component: () => import('@/views/TeacherManagement/index.vue'),
    meta: {
      hasNavigation: true,
      requireAuth: true,
      requireTeacher: true,
      depth: 1,
      activeTab: NAVIGATION.TABS.TEACHER,
    },
  },
  {
    path: '/teacher-management/student-information',
    name: 'student-information',
    component: () => import('@/views/TeacherManagement/StudentInformation.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
      depth: 1,
      activeTab: NAVIGATION.TABS.TEACHER,
    },
  },
  {
    path: '/teacher-management/student-information/:username',
    name: 'student-information-detail',
    component: () =>
      import('@/views/TeacherManagement/StudentInformationDetail.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
      depth: 1,
      activeTab: NAVIGATION.TABS.TEACHER,
    },
  },
  {
    path: '/teacher-management/student-information/:username/kifus',
    name: 'student-information-kifus',
    component: () => import('@/views/Kifu/Kifus.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
      depth: 1,
      isTeacherMode: true,
      activeTab: NAVIGATION.TABS.TEACHER,
    },
  },
  {
    path: '/teacher-management/student-information/:username/kifus/:createdTime/:gameMode',
    name: 'student-information-kifu-preview',
    component: () => import('@/views/Kifu/KifuPreview.vue'),
    meta: {
      hasNavigation: false,
      requireAuth: true,
      depth: 1,
      chessboardRoom: true,
      isTeacherMode: true,
      activeTab: NAVIGATION.TABS.TEACHER,
    },
  },
  {
    path: '/teacher-management/student-information/:username/scores',
    name: 'student-information-scores',
    component: () =>
      import('@/views/TeacherManagement/TeacherManagementPastScores.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
      depth: 1,
      activeTab: NAVIGATION.TABS.TEACHER,
    },
  },
  {
    path: '/teacher-management/student-information/:username/scores/:scoreId/:rank/:coursePlan',
    name: 'student-information-score',
    component: () => import('@/views/TeacherManagement/StudentScore.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
      depth: 1,
      chessboardRoom: true,
      activeTab: NAVIGATION.TABS.TEACHER,
    },
  },
  {
    path: '/teacher-management/multimedia-classroom-type-list',
    name: 'multimedia-classroom-type-list',
    component: () =>
      import('@/views/TeacherManagement/MultimediaClassroomTypeList.vue'),
    meta: {
      hasNavigation: true,
      requireDesktop: true,
      requireAuth: true,
      requireTeacher: true,
      depth: 1,
      activeTab: NAVIGATION.TABS.TEACHER,
    },
  },
  {
    path: '/teacher-management/multimedia-classroom-type-list/official/:typeId',
    name: 'multimedia-classroom-type-official',
    component: () =>
      import('@/views/TeacherManagement/MultimediaClassroomType.vue'),
    meta: {
      hasNavigation: true,
      requireDesktop: true,
      requireAuth: true,
      requireTeacher: true,
      depth: 1,
      isPublic: true,
      activeTab: NAVIGATION.TABS.TEACHER,
    },
  },
  {
    path: '/teacher-management/multimedia-classroom-type-list/private/:typeId',
    name: 'multimedia-classroom-type-private',
    component: () =>
      import('@/views/TeacherManagement/MultimediaClassroomType.vue'),
    meta: {
      hasNavigation: true,
      requireDesktop: true,
      requireAuth: true,
      requireTeacher: true,
      depth: 1,
      isPublic: false,
      activeTab: NAVIGATION.TABS.TEACHER,
    },
  },
  {
    path: '/teacher-management/kgp',
    name: 'kgp-list',
    component: () => import('@/views/TeacherManagement/KgpList.vue'),
    meta: {
      hasNavigation: true,
      requireDesktop: true,
      requireAuth: true,
      requireTeacher: true,
      depth: 1,
      activeTab: NAVIGATION.TABS.TEACHER,
    },
  },
  {
    path: '/teacher-management/kgp/:id',
    name: 'kgp-contents',
    component: () => import('@/views/TeacherManagement/KgpContents.vue'),
    meta: {
      hasNavigation: true,
      requireDesktop: true,
      requireAuth: true,
      requireTeacher: true,
      depth: 1,
      activeTab: NAVIGATION.TABS.TEACHER,
    },
  },
  {
    path: '/teacher-management/tgc',
    name: 'tgc-list',
    component: () => import('@/views/TeacherManagement/TgcList.vue'),
    meta: {
      hasNavigation: true,
      requireAuth: true,
      requireTeacher: true,
      depth: 1,
      activeTab: NAVIGATION.TABS.TEACHER,
    },
  },
  {
    path: '/teacher-management/tgc/:id',
    name: 'tgc-contents',
    component: () => import('@/views/TeacherManagement/TgcContents.vue'),
    meta: {
      hasNavigation: true,
      requireAuth: true,
      requireTeacher: true,
      depth: 1,
      activeTab: NAVIGATION.TABS.TEACHER,
    },
  },
  {
    path: '/teacher-management/student-pvp-management',
    name: 'studentPvpManagement',
    component: () =>
      import('@/views/TeacherManagement/StudentPvpManagement.vue'),
    meta: {
      hasNavigation: true,
      requireAuth: true,
      requireTeacher: true,
      depth: 1,
      activeTab: NAVIGATION.TABS.TEACHER,
    },
    beforeEnter: (to, from, next) => {
      if (isMobile) {
        return next({name: 'teacherManagement'});
      }
      next();
    },
  },
  {
    path: '/teacher-management/student-pvp-management/create',
    name: 'studentPvpCreate',
    component: () =>
      import('@/views/TeacherManagement/StudentPvpCreate.vue'),
    meta: {
      hasNavigation: true,
      requireAuth: true,
      requireTeacher: true,
      depth: 1,
      activeTab: NAVIGATION.TABS.TEACHER,
    },
  },
];
